import { Alert } from "@caspeco/casper-ui-library";
import { useIsMutating } from "@tanstack/react-query";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import AlertSkeleton from "components/skeletons/alert-skeleton";
import { useTranslation } from "react-i18next";
import { CurrencyDisplay } from "translations/currency";
import { PaymentEventType } from "types/payment";

const NoShowAlert = () => {
    const { t } = useTranslation();
    const isCreatingBooking = useIsMutating({ mutationKey: ["create-booking"] }) > 0;
    const { data: webBooking, isLoading: isLoadingBooking } = useWebBooking();

    if (isCreatingBooking || isLoadingBooking) return <AlertSkeleton />;

    const paymentEvent = webBooking?.paymentEvents?.find(
        (event) => event.type === PaymentEventType.NoShowCharge
    );

    if (!paymentEvent) return null;

    return (
        <Alert type="info" iconVerticalAlign="flex-start">
            {t("noShowInfoAlert", {
                value: paymentEvent.requestedAmount,
                display: CurrencyDisplay.Symbol,
            })}
        </Alert>
    );
};

export default NoShowAlert;
